/**
* Shopify Ajaxify Shop. 
* 
* @uses Modified Shopify jQuery API (link to it)
*
*/

jQuery(document).ready(function() { 
  //Begin Wrapper

  var jQ = jQuery;

/**
* Collection of Selectors for various pieces on the page we need to update 
*
*/
var selectors = {
  TOTAL_ITEMS: '.cart-total-items',
  TOTAL_PRICE: '.cart-total-price',
  SUBMIT_ADD_TO_CART: 'input[type=image], input.submit-add-to-cart'
};


/**
* Collection of text strings. This is where you would change for a diff language, for example. 
*
*/
var text = {
  ITEM: 'Item', 
  ITEMS: 'Items'
};

//Attach Submit Handler to all forms with the /cart/add action. 
jQ('form[action*=/cart/add]').submit(function(e) {
  e.preventDefault();
  //Disable the Add To Cart button, add a disabled class. 
  jQ(e.target).find(selectors.SUBMIT_ADD_TO_CART).attr('disabled', true).addClass('disabled');
  Shopify.addItemFromForm(e.target);
  });

/**
* Shopify.onItemAdded
* 
* Triggered by the response when something is added to the cart via the add to cart button.
* This is where you would want to put any flash messaging, for example.
* 
* @param object line_item
* @param HTMLelement/String Form HTMLElement, or selector
*/
Shopify.onItemAdded = function(line_item, form) {
  jQ(form).find(selectors.SUBMIT_ADD_TO_CART).attr('disabled', false).removeClass('disabled');

  Shopify.getCart();
  jQ.jGrowl("<a href='/cart'>" + line_item.title + " was added to your cart</a>.");
};

Shopify.onCartUpdate = function(cart) {
  var message = cart.item_count + " " +
  ((cart.item_count == 1) ? text.ITEM : text.ITEMS );
  message += " ~ " + Shopify.formatMoney(cart.total_price);
  jQ("#shopping-cart-summary").html(message);
};

Shopify.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  jQ.jGrowl(data.description);
  jQ("#add-to-cart").attr('disabled', 'disabled');
  jQ("#add-to-cart").addClass('disabled');
};

});